define(function(require, exports, module) {
    'use strict';

    var FormClass = require('class/form.class');
    var Class = require('Class');
    var $ = require('j');
    var util = require('utils');
    var _ = require('underscore');
    var userValidationConfig = require('modules/user/sportium-theme/user.validation.config.js');

    var Form = Class.create(FormClass, {

        initialize: function(form, options) {
            if (!form || !form.length && !(form instanceof window.HTMLFormElement)) {
                throw new Error('Form element is required.');
            }

            if (!(form instanceof $)) {
                form = $(form);
            }

            this.options = util.deepExtend({}, {
                id: _.uniqueId('form'),
                validationConfig: {},
                mutators: []
            }, options);

            this.isValid = true;
            this._customControls = [];
            this.hightlightControlClass = 'fn-highlight-control';
            this.validationInProgressFields = [];

            /* Sportium theme - validation for personal ID fix */
            var config = userValidationConfig();

            if (options && _.isObject(options.validationConfig)) {
                this.setValidationConfig(util.deepExtend({}, options.validationConfig, {
                    personalId: config.personalId
                }));
            }

            if (options && 'data' in options) {
                _.extend(this.options, {
                    data: options.data
                });
            }

            Object.defineProperty(this, '$elements', {
                configurable: true,
                get: function() {
                    return this.$el.find('.fn-validate');
                }
            });

            this.setElement(form);
        },
    });

    Form.toggleLoading = FormClass.toggleLoading;
    Form.refreshSelectField = FormClass.refreshSelectField;
    Form.toggleFieldVisibility = FormClass.toggleFieldVisibility;

    module.exports = Form;
});
